import { Component, Input, input, ChangeDetectionStrategy } from '@angular/core';

import { IconComponent } from '../../../common/icon/icon.component';
import type { IconName } from '../../../common/icon/icons.type';
import type { RadioGroupItem } from '../radio-form-group.component';

@Component({
  imports: [IconComponent],
  selector: 'rt-radio-form-group-item',
  templateUrl: './radio-form-group-item.component.html',
  styleUrls: ['./radio-form-group-item.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    '[class.disabled]': 'disabled()',
  },
})
export class RadioFormGroupItemComponent {
  public readonly icon = input<IconName>(undefined!);
  public readonly disabled = input<boolean>(false);
  @Input() public item: RadioGroupItem;
}
